export default "__VITE_ASSET___HvjPK0X__"